import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type { UpdateGroupsDataResponse } from "@ServerTypes/groups/groups.schema";

export async function getGroupData({ value }: any) {
  const response = await axiosWrapper.post<UpdateGroupsDataResponse>(`${getBackendUrl()}/groups/updateGroupsData`, {
    value,
  });
  return response.data.result;
}
